import { ACCOUNT_NEXTJS_URL } from 'config/vars'
import {
  MY_ACCESS_PATH,
  MY_ACCOUNT_PATH,
  MY_NOTIFICATION_PREFERENCES_PATH
} from 'routes/paths'

const ACCOUNT_NEXTJS_PATHS: Record<string, string> = {
  [MY_ACCOUNT_PATH]: '/app-v2/minha-conta',
  [MY_ACCESS_PATH]: '/app-v2/minha-conta/meu-acesso',
  [MY_NOTIFICATION_PREFERENCES_PATH]: '/app-v2/minha-conta/notificacoes'
}

export const getAccountNextjsUrl = (legacyPath: string): string => {
  const nextjsPath = ACCOUNT_NEXTJS_PATHS[legacyPath] ?? legacyPath
  return `${ACCOUNT_NEXTJS_URL}${nextjsPath}`
}

export const redirectToAccountNextjs = (legacyPath: string): void => {
  window.location.assign(getAccountNextjsUrl(legacyPath))
}
